// extracted by mini-css-extract-plugin
export default {"root":"ThankYouOrder_root__i1Q4U","section":"ThankYouOrder_section__r8JUC","bold":"ThankYouOrder_bold__lR8wC"};